<template>
    <div ref="reportSection" id="section-start" class="report-section">
        <div class="border rounded mb-3 pt-3 px-3 position-relative" v-if="any_active_charts == false && page.cache_only == false">
            <Transition name="fade" :duration="300">
                <div v-if="if_refreshing" class="loading-overlay">
                    <div role="status" class="d-inline-block spinner-border ms-2 spinner-border-lg"><span class="visually-hidden">Loading</span></div>
                    <p>Loading...</p>
                </div>
            </Transition>
            <div class="information-card-template">
                <div class="d-flex flex-row">
                    <div class="flex-shrink-1 insights-dashboard-group-icon me-2">
                        <div class="icon-red me-2"><img src="/img/icons/avid-icons/warning-circle.svg" alt=""></div></div>
                    <div class="flex-fill">
                        <h1>Invalid Filter Selection</h1>
                        <p>Based upon the filters selected, there are no records that match your criteria. Please update your filters and try again.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="chart-grid" v-else>
            <div class="row">
                <template v-for="(chart, i) in local_charts" :key="chart.id || i">
                  <div
                    v-if="checkIfShowChart(chart?.chart)"
                    :class="chart.size_class"
                    :id="chart.id"
                    class="size-container d-flex flex-column"
                    :data-size="chart.size"
                  >
                      <div :class="[chart.is_primary ? 'primary-holder' : '']" class="d-flex flex-column flex-grow-1" v-if="!chart?.title || !chart.title.toLowerCase().startsWith('divider')">
                          <div class="chart-container card position-relative mb-3 flex-grow-1" :class="[if_benchmark_report ? 'benchmark-'+chart?.subtitle : '']">
                              <Transition name="fade" :duration="300">
                                  <div v-if="if_refreshing && chart.id != applied_chart_filter?.section_chart_id && chart?.chart?.type!='information_card'" class="loading-overlay">
                                      <div role="status" class="d-inline-block spinner-border spinner-border-lg ms-2"><span class="visually-hidden">Loading</span></div>
                                      <p>Loading...</p>
                                  </div>
                              </Transition>
                                  <div class="grow" :class="[chart.if_zoomed_in ? 'zoomed-in-chart' : '']">
                                      <chart-template
                                          :chart="chart.chart"
                                          :section_title="chart.title"
                                          :id="chart.id" 
                                          :key="chart.id || i"
                                          :if_refreshing="if_refreshing" 
                                          :if_on_report_page="true" 
                                          :applied_chart_filter="applied_chart_filter" 
                                          :if_benchmark_report="if_benchmark_report"
                                          :show_data_labels="chart.show_data_labels !== undefined ? chart.show_data_labels : page_show_data_labels"
                                          :chart_show_data_labels="chart.show_data_labels"
                                          :page_show_data_labels="page_show_data_labels"
                                          :allow_download="client != null && chart?.chart?.type!='scorecard' && chart?.chart?.type!='information_card' && if_allow_export"
                                          :allow_label_toggle="chart?.chart?.type !== 'scorecard' && chart?.chart?.type !== 'information_card' && chart?.chart?.type !== 'table' && chart?.chart?.type !== 'multi_metric_scorecard' && chart?.chart?.type !== 'multi_dimension_table'"
                                          :allow_resize="chart?.chart?.type !== 'scorecard' && chart?.chart?.type !== 'information_card'"
                                          :allow_deep_dive="true"
                                          :if_zoomed_in="chart.if_zoomed_in"
                                          :current_size="chart.size"
                                          :page_filters="page?.filters || []"
                                          :page_dimensions="page?.dimensions || []"
                                          :section_filters="page_section?.filters || []"
                                          :section_id="page_section?.id"
                                          :is_filter_panel_expanded="is_filter_panel_expanded"
                                          :is_section_active="is_section_active"
                                          :should_show_summary="should_show_summary"
                                          :show_compressed_numbers="show_compressed_numbers"
                                          :chart_summary="chart_summaries[chart.id]"
                                          @exploreChart="exploreChart"
                                          @resizeChart="changeChartSize($event, i)"
                                          @chartReferenceClick="onChartReferenceClick"
                                          @downloadChart="downloadChart(chart, i)"
                                          @toggleDataLabels="toggleDataLabels(i, $event)"
                                      />
                                  </div>


                          </div>
                      </div>
                  </div>
                </template>

                <div v-if="if_benchmark_report && section_index < page.sections.length - 1" class="col-12">
                    <div class="float-end">
                        <h4><button type="button" class="btn btn-link p-0 text-decoration-none" @click="goToNextSection">Next Page: {{ next_section_title }} <i class="fa fas fa-arrow-right"></i></button></h4>
                    </div>
                </div>
            </div>
        </div>

        <div class="card key-takeaways-section col-12" 
             :class="{'is-generating': local_section?.takeaways==null}" 
             v-if="should_show_summary && (local_section?.takeaways==null || local_section?.takeaways?.length > 0) && areChartsActive(false) && !if_benchmark_report">
            <div class="card-body">
                <h3 class="mb-3">Key Takeaways</h3>

                <div class="key-takeaways-none d-flex" v-if="local_section?.takeaways==null">
                    <img src="/img/images/loading_edna.gif" class="loading-logo mx-2" style="width: 24px; height: 24px;" ></img>
                    <p class="mb-0">Your data is being analyzed. The results will be displayed here once the analysis is complete.</p>
                </div>

                <div class="key-takeaways-list row g-3" v-else>
                    <div v-for="takeaway in local_section?.takeaways" :key="takeaway.id" class="col-12 col-md-6 col-xl-4 key-takeaways-item">
                        <div class="card h-100">
                            <div class="card-header d-flex align-items-center">
                                <div class="key-takeaways-item--icon me-2">
                                    <img v-if="takeaway.icon == 'money'" class="icon" src="/img/icons/avid-icons/dollar-square.svg" alt="">
                                    <img v-if="takeaway.icon == 'number'" class="icon" src="/img/icons/avid-icons/people.svg" alt="">
                                    <img v-if="takeaway.icon == 'percent'" class="icon" src="/img/icons/avid-icons/percentage-square.svg" alt="">
                                    <img v-if="takeaway.icon == 'other'" class="icon" src="/img/icons/avid-icons/note-2.svg" alt="">
                                </div>                                       
                                <div class="key-takeaways-item--heading">
                                    <h4 class="mb-0" v-html="takeaway.title"></h4>                                          
                                </div>                           
                            </div>
                            <div class="card-body pt-0">
                                <div class="key-takeaways-item--text">
                                    <p class="mb-0" v-html="takeaway.html"></p>
                                    <Link v-if="takeaway.url != null" :href="takeaway.url" class="btn btn-primary btn-sm mt-2 px-3">
                                        Explore<img class="icon ms-1" src="/img/icons/avid-icons/chevron-right-double.svg" alt=""></img>
                                        
                                    </Link>  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import {Context} from "svgcanvas";
import chartExportMixin from '../../mixins/chart_export';
import { defineComponent } from 'vue';
import { Tooltip } from 'bootstrap';
import { Link } from '@inertiajs/vue3';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import permissionsMixin from '../../mixins/permissions';
import { marked } from 'marked';

export default defineComponent({
    name: 'ReportViewSection',
    mixins: [chartExportMixin, permissionsMixin],
    components: {
        Swal,
        Link
    },
    props: {
        page: {
            type: [Object, null],
        },
        client: {
            type: [Object, null],
        },
        user: {
            type: [Object, null],
            default: null
        },
        connections: {
            type: [Array, null],
        },
        page_section: {
            type: [Object, null],
        },
        chart_summaries: {
            type: Object,
            default: () => ({})
        },
        applied_chart_filter: {
            type: [Object, null],
            default: () => ({})
        },
        section_index: {
            type: Number,
            default: 0
        },
        is_filter_panel_expanded: {
            type: Boolean,
            default: false
        },
        if_refreshing: {
            type: Boolean,
            default: false
        },
        if_benchmark_report: {
            type: Boolean,
            default: false    // or set appropriate default/value as needed
        },
        if_allow_export: {
            type: Boolean,
            default: false
        },
        page_show_data_labels: {
            type: Boolean,
            default: false
        },
        is_section_active: {
            type: Boolean,
            default: true
        },
        should_show_summary: {
            type: Boolean,
            default: true
        },
        show_compressed_numbers: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            local_section: null,
            local_charts: [],
            formatted_rows: [],
            any_active_charts: true,
            debouncedAdjust: null,
            tooltips: [], // Add tooltips array
        };
    },
    beforeMount() {
        this.local_charts = JSON.parse(JSON.stringify(this.page_section.charts));
        this.local_section = {...this.page_section};
        this.local_charts.forEach((chart)=>{
            chart.if_zoomed_in = false;
            chart.show_data_labels = undefined; // Initialize as undefined to follow page-level setting
            chart.chart.size = chart.size;
        })
        this.formatChartObjectInArray();

        this.any_active_charts = this.areChartsActive();

        //It takes a second to generate the takeaways when they refresh
        if(!this.if_benchmark_report){
            if(this.any_active_charts && this.local_section.takeaways != null) {
                // add tooltip title to takeaway objects and convert markdown to HTML
                for (var i = 0; i <this.local_section.takeaways.length; i++){
                    this.local_section.takeaways[i].tooltip = 'By clicking on Explore button, you will be navigate to Report "" on Section "" with Filters as " " applied.'
                    if (this.local_section.takeaways[i].title) {
                        this.local_section.takeaways[i].title = this.markdownToHtml(this.local_section.takeaways[i].title);
                    }
                    if (this.local_section.takeaways[i].html) {
                        this.local_section.takeaways[i].html = this.markdownToHtml(this.local_section.takeaways[i].html);
                    }
                }
            }                
        }
    },
    mounted() {
        // Select all <a> elements within this component's root element
        const links = this.$el.querySelectorAll('a[rel="noopener noreferrer"]');
            
        // Iterate over each link and remove the 'rel' attribute
        links.forEach(link => {
            link.removeAttribute('rel');
            link.removeAttribute('target');
        });

        // Process summary if it exists (from cache) to add chart reference links
        if (this.local_section.summary && this.local_section.related_charts && this.local_section.related_charts.length > 0) {
            // Strip any existing chart reference links (they may have wrong IDs from cache)
            this.local_section.summary = this.local_section.summary.replace(/<a[^>]*class="chart-reference-link"[^>]*>(.*?)<\/a>/gi, '$1');
            // Reprocess with correct related_charts data
            this.local_section.summary = this.processChartReferences(this.local_section.summary, this.local_section.related_charts);
            // Convert any remaining markdown to HTML (after chart references are processed)
            this.local_section.summary = this.markdownToHtml(this.local_section.summary);
        }

        // Adjust insights on mount
        this.$nextTick(() => {
            this.initializeTooltips();
            // Attach click handlers for chart references if summary was processed
            if (this.local_section.summary && this.local_section.related_charts && this.local_section.related_charts.length > 0) {
                this.attachChartReferenceClickHandlers();
            }
        });
        
    },
    beforeUnmount() { // Use `beforeDestroy` if using Vue 2
        if (this.debouncedAdjust) {
            window.removeEventListener('resize', this.debouncedAdjust);
        }
    },
    computed: {
        next_section_title(){
            if(this.section_index < this.page.sections.length - 1){
                return this.page.sections[this.section_index + 1].title;
            }
            return '';
        }
    },
    watch:{
        page_section(new_value, old_value){
            this.local_charts = JSON.parse(JSON.stringify(this.page_section.charts));
            this.local_section = {...this.page_section};
            this.local_charts.forEach((chart)=>{
                chart.if_zoomed_in = false;
                chart.showResizeMenu = false;
                chart.show_data_labels = undefined; // Initialize as undefined to follow page-level setting
                chart.chart.size = chart.size;
            })
            this.formatChartObjectInArray();

            this.any_active_charts = this.areChartsActive();
            
            // Process summary if it exists (from cache) to add chart reference links
            if (this.local_section.summary && this.local_section.related_charts && this.local_section.related_charts.length > 0) {
                // Strip any existing chart reference links (they may have wrong IDs from cache)
                this.local_section.summary = this.local_section.summary.replace(/<a[^>]*class="chart-reference-link"[^>]*>(.*?)<\/a>/gi, '$1');
                // Reprocess with correct related_charts data
                this.local_section.summary = this.processChartReferences(this.local_section.summary, this.local_section.related_charts);
                // Convert any remaining markdown to HTML (after chart references are processed)
                this.local_section.summary = this.markdownToHtml(this.local_section.summary);
            }
            
            // Initialize tooltips after the section changes
            this.$nextTick(() => {
                this.initializeTooltips();
                // Attach click handlers for chart references if summary was processed
                if (this.local_section.summary && this.local_section.related_charts && this.local_section.related_charts.length > 0) {
                    this.attachChartReferenceClickHandlers();
                }
            });
        },
        is_filter_panel_expanded(new_value, old_value){
            this.formatChartObjectInArray();
            this.$forceUpdate();
        },
        if_refreshing(new_value, old_value){
            // Force update when refreshing state changes to ensure loading overlay updates
            if (!new_value && old_value) {
                // When switching from refreshing to not refreshing, force a re-render
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            }
        }
    },
    methods: {
        zoomOnChart(chart, i){
            if(chart.if_zoomed_in){
                this.local_charts[i].size = this.local_section.charts[i].size;
                if(this.local_charts[i].size=='small'){
                    this.local_charts[i].size_class='col-md-4 col-12';
                }else if(this.local_charts[i].size=='medium'){
                    this.local_charts[i].size_class='col-md-6 col-12';
                }else if(this.local_charts[i].size=='large'){
                    this.local_charts[i].size_class='col-md-8 col-12';
                }else if(this.local_charts[i].size=='fullsize'){
                    this.local_charts[i].size_class='col-12';
                }
            }else{
                this.local_charts[i].size = 'fullsize';
                this.local_charts[i].size_class = "col-12";
            }
            this.local_charts[i].if_zoomed_in = !this.local_charts[i].if_zoomed_in;
            this.local_charts[i].chart.size = this.local_charts[i].size;
            this.$forceUpdate();

        },
        downloadChart(chart_div, i) {
            //Add the necessary modifications to canvas2svg library to work with chartjs
            Context.prototype.getContext = function (contextId) {
                if (contextId=="2d" || contextId=="2D")
                    return this;
                return null;
            }
            Context.prototype.style = function () { return this.__canvas.style }
            Context.prototype.getAttribute = function (name) { return this[name];}
            Context.prototype.addEventListener =  function(type, listener, eventListenerOptions) {}

            this.loading = true;
            window.axios.get('/api/export/sizes/' + this.client.id)
                .then(response => {
                    var sizes = response.data.sizes;
                    
                    let container = document.getElementById(chart_div.id);
                    if (!container) {
                        console.error('Chart container not found:', chart_div.id);
                        this.loading = false;
                        return;
                    }
                    
                    let originalChart = container.querySelector('canvas');
                    if (!originalChart) {
                        console.error('Chart canvas not found in container:', chart_div.id);
                        this.loading = false;
                        return;
                    }

                    const chartjs = Chart.getChart(originalChart);
                    if (!chartjs) {
                        console.error('Chart.js instance not found for export');
                        this.loading = false;
                        return;
                    }

                    // Create a temporary container and canvas for export
                    const tempContainer = document.createElement('div');
                    tempContainer.style.position = 'absolute';
                    tempContainer.style.left = '-9999px';
                    tempContainer.style.top = '-9999px';
                    document.body.appendChild(tempContainer);

                    const tempCanvas = document.createElement('canvas');
                    tempContainer.appendChild(tempCanvas);
                    
                    // Default sizes if API fails or returns incomplete data
                    const defaultSizes = {
                        FULL_WIDTH: { width: 1200, height: 600 },
                        SINGLE_SMALL: { width: 400, height: 300 }
                    };

                    let size = container.dataset.size;
                    let exportWidth, exportHeight;
                    
                    if (size == 'fullsize' || size == 'large') {
                        exportWidth = sizes?.FULL_WIDTH?.width || defaultSizes.FULL_WIDTH.width;
                        exportHeight = sizes?.FULL_WIDTH?.height || defaultSizes.FULL_WIDTH.height;
                    }
                    else if (size == 'small') {
                        exportWidth = sizes?.SINGLE_SMALL?.width || defaultSizes.SINGLE_SMALL.width;
                        exportHeight = sizes?.SINGLE_SMALL?.height || defaultSizes.SINGLE_SMALL.height;
                    }
                    else {
                        exportWidth = sizes?.FULL_WIDTH?.width || defaultSizes.FULL_WIDTH.width;
                        exportHeight = sizes?.FULL_WIDTH?.height || defaultSizes.FULL_WIDTH.height;
                    }

                    // Set canvas dimensions
                    tempCanvas.width = exportWidth;
                    tempCanvas.height = exportHeight;
                    tempCanvas.dataset.width = exportWidth;
                    tempCanvas.dataset.height = exportHeight;
                    
                    // Clone the chart configuration with specific options for export
                    const chartType = chartjs.config.type;
                    const chartUsesScales = ['bar', 'line', 'scatter', 'bubble'].includes(chartType);
                    
                    // Prepare scales config (only for charts that use scales)
                    let scalesConfig = {};
                    if (chartUsesScales && chartjs.config.options.scales) {
                        scalesConfig = {
                            ...chartjs.config.options.scales,
                        };
                        
                        if (chartjs.config.options.scales.x) {
                            scalesConfig.x = {
                                ...chartjs.config.options.scales.x,
                                ticks: {
                                    ...(chartjs.config.options.scales.x.ticks || {}),
                                    ...(chartjs.config.options.scales.x.ticks?.font ? { font: chartjs.config.options.scales.x.ticks.font } : {})
                                }
                            };
                        }
                        
                        if (chartjs.config.options.scales.y) {
                            scalesConfig.y = {
                                ...chartjs.config.options.scales.y,
                                ticks: {
                                    ...(chartjs.config.options.scales.y.ticks || {}),
                                    ...(chartjs.config.options.scales.y.ticks?.font ? { font: chartjs.config.options.scales.y.ticks.font } : {}),
                                    ...(chartjs.config.options.scales.y.ticks?.callback ? { callback: chartjs.config.options.scales.y.ticks.callback } : {})
                                }
                            };
                        }
                    }
                    
                    // Get current datasets and filter out hidden ones using Chart.js visibility API
                    const currentDatasets = chartjs.data.datasets || [];
                    
                    // Get hidden dataset indices from legend (most reliable when user clicks legend)
                    const hiddenIndices = new Set();
                    try {
                        if (chartjs.legend && chartjs.legend.legendItems) {
                            chartjs.legend.legendItems.forEach((item, index) => {
                                if (item.hidden === true || item.hidden === 'true') {
                                    hiddenIndices.add(item.datasetIndex !== undefined ? item.datasetIndex : index);
                                }
                            });
                        }
                    } catch (e) {
                        // If legend check fails, continue with other methods
                    }
                    
                    const visibleDatasets = currentDatasets.filter((ds, index) => {
                        // First check if this index is in the hidden set from legend
                        if (hiddenIndices.has(index)) {
                            return false;
                        }
                        
                        // Check dataset meta for visibility state
                        try {
                            const meta = chartjs.getDatasetMeta ? chartjs.getDatasetMeta(index) : null;
                            if (meta && (meta.hidden === true || meta.hidden === 'true')) {
                                return false;
                            }
                        } catch (e) {
                            // If getDatasetMeta fails, continue with other checks
                        }
                        
                        // Use Chart.js API to check if dataset is actually visible
                        try {
                            if (chartjs.isDatasetVisible && typeof chartjs.isDatasetVisible === 'function') {
                                if (!chartjs.isDatasetVisible(index)) {
                                    return false;
                                }
                            }
                        } catch (e) {
                            // If isDatasetVisible fails, continue with other checks
                        }
                        
                        // Also check the hidden property on the dataset itself
                        if (ds.hidden === true || ds.hidden === 'true') {
                            return false;
                        }
                        
                        return true;
                    });
                    
                    // Create filtered data object with only visible datasets
                    const filteredData = this.getVisibleChartData(chartjs);

                    // Build export config and ensure datalabel formatter preserves original visibility
                    const exportConfig = {
                        type: chartType,
                        data: filteredData,
                        options: {
                            ...JSON.parse(JSON.stringify(chartjs.config.options)),
                            responsive: false,
                            maintainAspectRatio: false,
                            animation: false,
                            layout: {
                                padding: chartjs.config.options.layout?.padding || 0
                            },
                            ...(Object.keys(scalesConfig).length > 0 && { scales: scalesConfig }),
                            plugins: {
                                ...chartjs.config.options.plugins,
                                legend: {
                                    ...chartjs.config.options.plugins.legend,
                                    labels: {
                                        ...chartjs.config.options.plugins.legend.labels,
                                        ...(chartjs.config.options.plugins.legend.labels?.font ? { font: chartjs.config.options.plugins.legend.labels.font } : {})
                                    }
                                }
                            }
                        }
                    };

                    this.wrapDatalabelFormatter(exportConfig, chartjs, filteredData);

                    const tempChart = new Chart(tempCanvas, {
                        ...exportConfig,
                        plugins: [ChartDataLabels]
                    });

                    // Force multiple renders to ensure stability
                    tempChart.update('none');
                    tempChart.update('none');
                    
                    // Wait for the chart to be fully rendered
                    setTimeout(() => {
                        //If it is a chart
                        let svg = this.convertToSVG(tempCanvas);
                        svg = this.updateTextElements(svg);
                        if(container.querySelector('.line-chart-template') || container.querySelector('.bar-line-chart-template')){
                            svg = this.addLinesToChart(svg);
                        }

                        // Use filtered data (without hidden datasets) for export
                        let chart_data = filteredData;

                        let data = {
                            client: this.client,
                            page: this.page,
                            params: (document.location.search!='') ? document.location.search.substring(1) : '',
                            svg: {
                                id: chart_div.id,
                                title: chart_div.chart.title, 
                                subtitle: chart_div.chart.subtitle, 
                                svg: svg,
                                data: chart_data,
                                size: size
                            }
                        };

                        window.axios.post('/api/export/chart', data, { responseType: 'blob' })
                            .then(response => {
                                // Create a URL for the blob and trigger a download
                                const url = window.URL.createObjectURL(new Blob([response.data]));
                                const link = document.createElement('a');
                                link.href = url;

                                let name = chart_div.chart.title + ' - Chart #' + chart_div.id + ' - ' + this.getDate() + '.pptx';

                                link.setAttribute('download', name);
                                document.body.appendChild(link);
                                link.click();
                                link.remove();
                                this.loading = false;

                                // Clean up temporary elements
                                tempChart.destroy();
                                tempContainer.remove();
                            })
                            .catch(error => {
                                console.error(error);
                                // Clean up temporary elements
                                tempChart.destroy();
                                tempContainer.remove();
                            });
                    }, 100); // Small delay to ensure chart is rendered
                })
                .catch(error => {
                    console.error('Error in export routine:', error);
                    this.loading = false;
                    Swal.fire({
                        icon: 'error',
                        title: 'Export Failed',
                        text: 'There was an error preparing the chart for export. Please try again.'
                    });
                });
        },
        areChartsActive(include_text_box = true){
            //If a chart is a text box or the data is empty, it doesn't count
            for(var i = 0; i < this.local_charts.length; i++){
                let chart = this.local_charts[i].chart;
                //If there is a information_card at the top; it will have instructions for empty pages
                if(include_text_box && i == 0 && chart.type == 'information_card' && chart.html != '') return true;

                if(chart.type == 'information_card' && chart.html != '') continue;
                if(!chart.data || Object.keys(chart.data).length == 0){
                    continue;
                } else if(!chart.labels || chart.labels.length ==0
                || (chart.labels.length == 1 && chart.labels[0] && chart.labels[0] == '(No Data)') )
                    continue;
                return true;
            }
            return false;
        },
        checkIfShowChart(chart){
            if(chart.type == 'information_card' && chart.html != '')
                return true;

            if(this.page.cache_only == true) {
                return true;
            }

            if(!chart.data || Object.keys(chart.data).length == 0){
                return false;
            } else if(!chart.labels || chart.labels.length ==0 
            || (chart.labels.length == 1 && chart.labels[0] && chart.labels[0] == '(No Data)') ){
                return false;
            }else{
                return true;
            }
        },
        formatChartObjectInArray(){
            if(this.is_filter_panel_expanded){
                for (var i = 0; i< this.local_charts.length; i++){
                    this.local_charts[i].size_class='col-12';
                }
            } else{
                for (var i = 0; i< this.local_charts.length; i++){
                    if(this.local_charts[i].size=='small'){
                        this.local_charts[i].size_class='col-md-4 col-12';
                    }else if(this.local_charts[i].size=='medium'){
                        this.local_charts[i].size_class='col-md-6 col-12';
                    }else if(this.local_charts[i].size=='large'){
                        this.local_charts[i].size_class='col-md-8 col-12';
                    }else if(this.local_charts[i].size=='fullsize' || this.local_charts[i].size=='x-large'){
                        this.local_charts[i].size_class='col-12';
                    }
                }
            }
        },
        changeChartSize(event, i) {
            const { size } = event;
            this.local_charts[i].size = size;
            if (this.local_charts[i].chart) {
                this.local_charts[i].chart.size = size;
            }
            this.formatChartObjectInArray();
            this.$forceUpdate();
            if (size === 'x-large') {
                this.fetchChartSummaryForResize(this.local_charts[i]);
            }
        },
        fetchChartSummaryForResize(chart) {
            if (!this.page || !this.page_section || !chart || !chart.id) return;
            this.$emit('chart-summary-queued', chart.id);
            const form_data = { page: this.getMinimalPageForTakeaways() };
            window.axios.post('/api/insights/section/' + this.page_section.id + '/chart/' + chart.id + '/takeaways', form_data)
                .then(response => {
                    if (response.data.status === 'completed') {
                        this.$emit('chart-summary-completed', {
                            chartId: chart.id,
                            summary: response.data.summary ?? null,
                            related_charts: response.data.related_charts ?? []
                        });
                    }
                })
                .catch(() => {});
        },
        getMinimalPageForTakeaways() {
            if (!this.page) return {};
            const p = JSON.parse(JSON.stringify(this.page));
            delete p.client;
            if (p.sections && Array.isArray(p.sections)) {
                p.sections.forEach(section => {
                    if (section.charts && Array.isArray(section.charts)) {
                        section.charts.forEach(chart => {
                            if (chart && chart.chart) {
                                delete chart.chart.data;
                                delete chart.chart.labels;
                                delete chart.chart.metric_formats;
                            }
                        });
                    }
                });
            }
            return p;
        },
        toggleDataLabels(index, data) {
            // Use the current effective value from ChartTemplate (no need to duplicate logic)
            const currentValue = data.currentValue;
            
            // Toggle to the opposite value and set it explicitly (not undefined)
            this.local_charts[index].show_data_labels = !currentValue;
            
            // Hide tooltip and blur button to prevent tooltip from sticking
            if (data.event && data.event.currentTarget) {
                const button = data.event.currentTarget;
                // Hide Bootstrap tooltip
                const tooltip = bootstrap.Tooltip.getInstance(button);
                if (tooltip) {
                    tooltip.hide();
                }
                // Blur the button to ensure tooltip disappears
                button.blur();
            }
            
            this.$forceUpdate();
        },
        exploreChart(details){
            details.section_index = this.section_index;
            this.$emit("exploreChartInSection", details);
        },
        updateInsights(data){
            // Handle null or undefined data
            if (data == null) {
                this.local_section.takeaways = [];
                this.local_section.summary = null;
                this.local_section.related_charts = [];
                return;
            }

            // Parse JSON string if needed (Echo events may send strings)
            if (typeof data === 'string') {
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    console.error('Error parsing insights data:', e);
                    this.local_section.takeaways = [];
                    this.local_section.summary = null;
                    this.local_section.related_charts = [];
                    return;
                }
            }

            //Make sure it has some value
            if(data.takeaways == null){
                data.takeaways = [];
            }

            //Set the tooltips and convert markdown to HTML
            for (var i = 0; i <data.takeaways.length; i++){
                data.takeaways[i].tooltip = 'By clicking on Explore button, you will be navigate to Report "" on Section "" with Filters as " " applied.'
                if (data.takeaways[i].title) {
                    data.takeaways[i].title = this.markdownToHtml(data.takeaways[i].title);
                }
                if (data.takeaways[i].html) {
                    data.takeaways[i].html = this.markdownToHtml(data.takeaways[i].html);
                }
            }

            this.local_section.takeaways = data.takeaways;
            this.local_section.summary = data.summary;
            this.local_section.related_charts = data.related_charts || [];

            // Process summary to add clickable chart references
            // First strip any existing chart reference links (they may have wrong IDs from cache)
            if (this.local_section.summary) {
                // Remove existing chart-reference-link anchors but keep the text
                this.local_section.summary = this.local_section.summary.replace(/<a[^>]*class="chart-reference-link"[^>]*>(.*?)<\/a>/gi, '$1');
            }
            
            // Now reprocess with correct related_charts data
            if (this.local_section.summary && this.local_section.related_charts && this.local_section.related_charts.length > 0) {
                this.local_section.summary = this.processChartReferences(this.local_section.summary, this.local_section.related_charts);
                // Convert any remaining markdown to HTML (after chart references are processed)
                this.local_section.summary = this.markdownToHtml(this.local_section.summary);
            }

            this.$nextTick(() => {
                this.attachChartReferenceClickHandlers();
            });
            this.$forceUpdate();
        },
        processChartReferences(summary, relatedCharts) {
            if (!summary || !relatedCharts || relatedCharts.length === 0) {
                return summary;
            }

            let processedSummary = summary;

            // Create a map of chart titles to chart data for quick lookup
            const chartMap = {};
            relatedCharts.forEach(chart => {
                if (chart.chart_title) {
                    chartMap[chart.chart_title] = chart;
                }
            });

            // Sort chart titles by length in descending order (longest first)
            // This ensures "Revenue per Donor" is matched before "Revenue"
            const sortedChartTitles = Object.keys(chartMap).sort((a, b) => b.length - a.length);

            // Replace chart title mentions with clickable links
            sortedChartTitles.forEach(chartTitle => {
                const chart = chartMap[chartTitle];
                
                // Ensure we're using actual database IDs, not array positions
                const chartId = parseInt(chart.chart_id, 10);
                const sectionId = parseInt(chart.section_id, 10);
                
                // Validate IDs are actual database IDs (not array indices)
                if (!chartId || !sectionId || chartId <= 0 || sectionId <= 0) {
                    console.warn('Invalid chart reference IDs:', chart);
                    return; // Skip invalid IDs
                }
                
                // Escape special regex characters in chart title (excluding * since titles shouldn't have them)
                const escapedTitle = chartTitle.replace(/[.+?^${}()|[\]\\]/g, '\\$&');
                // Create regex to find chart title mentions, accounting for markdown formatting (**, *, etc.)
                // This matches the title even if wrapped in markdown like **title** or *title*
                // Pattern: optional markdown asterisks (0-2) before, then the title, then optional markdown asterisks (0-2) after
                const regex = new RegExp(`(\\*{0,2})(?<!<a[^>]*>)(?<!["'])\\b${escapedTitle}\\b(?![^<]*</a>)(\\*{0,2})`, 'gi');
                
                processedSummary = processedSummary.replace(regex, (match) => {
                    // Replace the entire match (including markdown) with just the link (no markdown in link text)
                    return `<a href="#" class="chart-reference-link" data-chart-id="${chartId}" data-section-id="${sectionId}" data-is-same-section="${chart.is_same_section}">${chartTitle}</a>`;
                });
            });

            return processedSummary;
        },
        attachChartReferenceClickHandlers() {
            this.$nextTick(() => {
                const links = this.$el.querySelectorAll('.chart-reference-link');
                links.forEach(link => {
                    // Remove existing listeners to avoid duplicates
                    const newLink = link.cloneNode(true);
                    link.parentNode.replaceChild(newLink, link);
                    
                    newLink.addEventListener('click', (e) => {
                        e.preventDefault();
                        const chartId = parseInt(newLink.getAttribute('data-chart-id'));
                        const sectionId = parseInt(newLink.getAttribute('data-section-id'));
                        const isSameSection = newLink.getAttribute('data-is-same-section') === 'true';
                        
                        this.scrollToChart(chartId, sectionId, isSameSection);
                    });
                });
            });
        },
        onChartReferenceClick({ chartId, sectionId, isSameSection }) {
            this.scrollToChart(chartId, sectionId, isSameSection);
        },
        scrollToChart(chartId, sectionId, isSameSection) {
            if (isSameSection) {
                // Scroll within same section
                const chartElement = document.getElementById(chartId);
                if (chartElement) {
                    // Find the card inside the size-container
                    const cardElement = chartElement.querySelector('.chart-container.card');
                    const elementToHighlight = cardElement || chartElement;
                    
                    // Brief highlight on the card
                    elementToHighlight.style.transition = 'box-shadow 0.3s ease';
                    elementToHighlight.style.boxShadow = '0 0 20px rgba(0, 123, 255, 0.5)';
                    setTimeout(() => {
                        elementToHighlight.style.boxShadow = '';
                    }, 2000);
                    
                    // Scroll to chart container
                    chartElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            } else {
                // Cross-section navigation - emit event to parent
                this.$emit('scrollToChartInSection', {
                    chart_id: chartId,
                    section_id: sectionId,
                });
            }
        },
        goToNextSection(){
            this.$emit('goToNextSection', null);
        },
        initializeTooltips() {
            // Destroy existing tooltips first
            this.tooltips.forEach(tooltip => {
                tooltip.dispose();
            });
            this.tooltips = [];

            // Initialize new tooltips
            if (this.sectionRef) {
                const tooltipElements = this.sectionRef.querySelectorAll('[data-bs-toggle="tooltip"]');
                tooltipElements.forEach(element => {
                    const tooltip = new Tooltip(element);
                    this.tooltips.push(tooltip);
                });
            }
        },
        markdownToHtml(text) {
            if (!text) {
                return text;
            }

            // Use marked to properly parse markdown (handles nested bold/italic correctly)
            let html = marked.parse(text, { breaks: true });
            
            // Remove any remaining asterisks that weren't converted (cleanup for orphaned asterisks)
            html = html.replace(/\*/g, '');
            
            return html;
        },
    }
});
</script>
